import React from 'react'
import { Typography } from '@mui/material'
import { UseFormRegister } from 'react-hook-form'
import ScanCode from '../../../components/ScanCode/ScanCode'
import TextLabel from '../../../components/TextLabel/TextLabel'
import UserGuidance from '../../../components/UserGuidance/UserGuidance'
import theme from 'src/styles/theme'
import * as S from '../DivergenceProductPage.styles'

interface ProductFormData {
  barcode: string
}

interface ProductStepProps {
  divergenceActiveAddress: string | undefined
  divergenceActiveProductDesc: string | undefined
  onProductSubmit: () => void
  registerProduct: UseFormRegister<ProductFormData>
  handleProductNotFound: () => void
}

const ProductStep: React.FC<ProductStepProps> = ({
  divergenceActiveAddress,
  divergenceActiveProductDesc,
  onProductSubmit,
  registerProduct,
  handleProductNotFound,
}) => (
  <>
    <S.Info>
      <S.ContainerProductName>
        <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>Endereço</Typography>
        <UserGuidance>
          <TextLabel
            width='100%'
            height='3.2rem'
            backgroundColor={theme.colors.green4}
          >
            <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>
              {divergenceActiveAddress}
            </Typography>
          </TextLabel>
        </UserGuidance>
      </S.ContainerProductName>
      <S.ContainerProductName>
        <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>Produto</Typography>
        <UserGuidance>
          <TextLabel
            width='100%'
            height='3.2rem'
          >
            <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>
              {divergenceActiveProductDesc}
            </Typography>
          </TextLabel>
        </UserGuidance>
      </S.ContainerProductName>
    </S.Info>
    <S.Form>
      <ScanCode
        text='Ao localizar o produto bipe o código de barras.'
        onSubmit={onProductSubmit}
        register={registerProduct}
        dataTestId='input-barcode-test-id'
        inputName='barcode'
        errorMessage='Código de barras inválido!'
      />
      <S.ContainerButton>
        <S.CustomButton
          title='Não encontrei o produto'
          bgColor='cancel'
          hoverColor='cancelHover'
          letterColor='white'
          data-testid='button-not-found-product-test-id'
          onClick={handleProductNotFound}
        />
      </S.ContainerButton>
    </S.Form>
  </>
)

export default ProductStep
